// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonDiv {
    display: flex;
    flex-direction: row;
    justify-content: end;
    margin-bottom: 24px;
    gap:12px;
}

#print_container_checkList {
    width: 816px;
    height: auto;
    display: flex;
    flex-direction: column;
    font-size: small;
    border: 1px solid black;
    padding: 0px;
}

/*HEADER*/
.header {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 15%;
    border: 1px solid black;
}

.header>.headerTitle {
    font-weight: bold;
    padding: 12px;
    border-bottom: 1px solid black;
    text-align: center;
    background-color: rgba(128, 128, 128, 0.582);
    height: 28%;
}

.header>.headerNumerocontenedor {
    width: 100%;
    height: 45%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid black;
}

.header>.headerTipoContenedor {
    width: 100%;
    height: 45%;
    display: flex;
    flex-direction: row;
}

.header>.headerNumerocontenedor>.logo {
    width: 10%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.header>.headerNumerocontenedor>.nrooContainer {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
    border-left: 1px solid black;
}

.header>.headerNumerocontenedor>.nrooContainer>.titlenroContainer {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid black;
}

.header>.headerNumerocontenedor>.nrooContainer>.nroDescriptionContainer {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.header>.headerNumerocontenedor>.nrooContainer>.nroDescriptionContainer>.div1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-right: 1px solid black;
}

.header>.headerNumerocontenedor>.nrooContainer>.nroDescriptionContainer>.div2 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.header>.headerNumerocontenedor>.patioPlanta {
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.header>.headerNumerocontenedor>.patioPlanta>.patio {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.patio>.titlePatio {
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.patio>.Fecha {
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.patio>.Fecha div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-right: 1px solid black;
}


.header>.headerNumerocontenedor>.patioPlanta>.planta>.Fecha div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-right: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.patio>.FechaResult {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;

}

.header>.headerNumerocontenedor>.patioPlanta>.patio>.FechaResult div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-right: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.planta {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.header>.headerNumerocontenedor>.patioPlanta>.planta>.titlePlanta {
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.planta>.Fecha {
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid black;
}

.header>.headerNumerocontenedor>.patioPlanta>.planta>.FechaResult {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.header>.headerNumerocontenedor>.patioPlanta>.planta>.FechaResult div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-right: 1px solid black;
}


.header>.headerTipoContenedor>.nroIdChequeo {
    width: 10%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;

}

.header>.headerTipoContenedor>.descripcionPatiosNaviera {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
    border-left: 1px solid black;
}

.header>.headerTipoContenedor>.descripcionPatiosNaviera>.patioOrigen {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid black;

}

.header>.headerTipoContenedor>.descripcionPatiosNaviera>.patioOrigen>.titlePatio {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
    font-weight: bold;
}

.header>.headerTipoContenedor>.descripcionPatiosNaviera>.patioOrigen>.contentPatio {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

}

.header>.headerTipoContenedor>.descripcionPatiosNaviera>.Naviera {
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;

}

.header>.headerTipoContenedor>.descripcionPatiosNaviera>.Naviera>.titleNaviera {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
    font-weight: bold;
}

.header>.headerTipoContenedor>.descripcionPatiosNaviera>.Naviera>.contentNaviera {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

}

.header>.headerTipoContenedor>.horaFecha {
    display: flex;
    width: 30%;
    height: 100%;
    flex-direction: row;
    justify-content: space-between;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent1 {
    display: flex;
    height: 100%;
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent1>.hora {
    display: flex;
    height: 40%;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid black;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent1>.hora>.horaTitle {
    display: flex;
    height: 100%;
    width: 34%;
    flex-direction: row;
    border-right: 1px solid black;
}


.header>.headerTipoContenedor>.horaFecha>.horaContent1>.hora>.horaDesc {
    display: flex;
    height: 100%;
    width: 70%;
    flex-direction: row;
    justify-content: center;
    align-items: start;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent2 {
    display: flex;
    height: 100%;
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid black;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent2>.hora {
    display: flex;
    height: 40%;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid black;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent2>.hora>.horaTitle {
    display: flex;
    height: 100%;
    width: 35%;
    flex-direction: row;
    border-right: 1px solid black;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent1>.tipoRegistro {
    display: flex;
    height: 60%;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 8pt;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent2>.tipoRegistro {
    display: flex;
    height: 60%;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 8pt;
}

.header>.headerTipoContenedor>.horaFecha>.horaContent2>.hora>.horaDesc {
    display: flex;
    height: 100%;
    width: 70%;
    flex-direction: row;
    justify-content: center;
    align-items: start;
}


/*HEADER*/


/*CUESTIONARIO*/

/*CUESTIONARIO*/

.answers {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
}

.answers>.respuestasOpciones {
    width: 100%;
    height: 3%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid black;
}

.answers>.respuestasOpciones>.spceBlank {
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: row;
    border-right: 1px solid black;
}

.answers>.respuestasOpciones>.opciones {
    display: flex;
    flex-direction: row;
    width: 30%;
}

.answers>.respuestasOpciones>.opciones>.op1 {
    display: flex;
    flex-direction: row;
    width: 50%;
}

.answers>.respuestasOpciones>.opciones>.op1>div {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    border-right: 1px solid black;
    font-size: xx-small;
}

.answers>.respuestasOpciones>.opciones>.op2 {
    display: flex;
    flex-direction: row;
    width: 50%;
}

.answers>.interiorContenenedorTitle {
    width: 100%;
    border: 1px solid black;
    text-align: start;
    height: auto;
    padding: 0;

}

.answers>.respuestasOpciones>.opciones>.op2>div {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    border-right: 1px solid black;
    font-size: xx-small;
}

.answers>.interiorContenenedorTitle>.title {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
    font-size: x-small;
    background-color: rgba(128, 128, 128, 0.582);

}

.answers>.interiorContent {
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid black;
}

.answers>.interiorContent .contents {
    display: flex;
    width: 70%;
    flex-direction: column;
    border-right: 1px solid black;
}

.answers>.interiorContent .contents .content1,
.answers>.interiorContent .contents .content2 {
    text-align: start;
    display: flex;
    align-items: center;
    height: auto;
    /* Centra verticalmente */
    justify-content: flex-start;
    margin-left: 5px;
    font-size: xx-small;

}

.answers>.interiorContent .opciones {
    display: flex;
    flex-direction: row;
    width: 30%;
}

.answers>.interiorContent .opciones .op1 {
    display: flex;
    width: 50%;
    border-right: 1px solid black;
}

.answers>.interiorContent .opciones .op1 div {
    display: flex;
    width: 100%;
    border-right: 1px solid black;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: x-small;
    font-weight: bold;
}

.answers>.interiorContent .opciones .op2 {
    display: flex;
    width: 50%;
    border-right: 1px solid black;
}

.answers>.interiorContent .opciones .op2 div {
    display: flex;
    width: 100%;
    border-right: 1px solid black;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: xx-small;
    font-weight: bold;

}


.footer {
    width: 99.8%;
}

.footer1 {
    width: 100%;
    height: 154px;
    /* background-color: aqua; */
    display: flex;
    flex-direction: row;
}

.footer1 .primerParte {
    width: 50%;
    display: flex;
    flex-direction: column;
    /* background-color: blueviolet; */
    border-right: 1px solid black;
}

.footer1 .primerParte {
    border-right: 1px solid black;
}

.footer1 .footerContentSellos {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid black;
}

.footer1 .sellosCarat {
    text-align: start;
    width: 60%;
    height: auto;
    margin-left: 5px;
    border-right: 1px solid black;
    font-size: xx-small;
    /* Espacio entre los elementos */
}

.footer1 .selloBtllaH {
    text-align: center;
    width: 40%;
    display: flex;
    flex-direction: column;
}

.footer1 .selloBtllaH .titleSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}

.footer1 .selloBtllaH .descrSello {
    font-weight: lighter;
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: center;
    height: 70%;
    text-transform: uppercase;
    font-size: x-small;
}

.footer1 .terminal {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.footer1 .primerParte .terminal .vertical1 {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-align: center;
    font-size: 6pt;
    width: 12%;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid black;
}



.footer1 .firmayNombre {
    display: flex;
    flex-direction: column;
    width: 57.5%;
    border-right: 1px solid black;
    height: 84px;
}

.footer1 .firmayNombre .firma {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 14.5%;
    border-bottom: 1px solid black;
    font-size: x-small;
}

.footer1 .firmayNombre .firma .firm {
    display: flex;
    flex-direction: column;
    width: 49.4%;
    height: 100%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
    text-align: center;
    align-items: center;
   
}

.footer1 .firmayNombre .firma .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    justify-content: center;
}

.footer1 .firmayNombre .nombre {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 45%;
    border-bottom: 1px solid black;
}

.footer1 .firmayNombre .nombre .firm {
    display: flex;
    flex-direction: column;
    width: 49.4%;
    height: 100%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
    font-size: x-small;
    align-items: center;
    text-align: center;
}

.footer1 .firmayNombre .nombre .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    justify-content: center;
    font-size: xx-small;
    text-align: center;
}

.footer1 .firmayNombre .cedula {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 36%;
    /* border-bottom: 1px solid black; */
}

.footer1 .firmayNombre .cedula .firm {
    display: flex;
    flex-direction: column;
    width: 49.4%;
    height: 111%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
    font-size: x-small;
    text-align: center;
}

.footer1 .firmayNombre .cedula .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    justify-content: center;
    text-transform: uppercase;
    font-size: xx-small;
    text-align: center;
}

.footer1 .sellos {
    display: flex;
    flex-direction: column;
    width: 40%;
    height: 75%;
}


.footer1 .sellos .titleSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}

.footer1 .sellos .contentSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 40%;
    align-items: center;
    justify-content: center;
    display: flex;
}

.footer1 .sellos .titleOpLogis {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}

.footer1 .secondParte {
    width: 50%;
    display: flex;
    flex-direction: flex;
    /* background-color: rgb(86, 48, 121); */
}

.footer1 .secondParte .vertical2 {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-align: center;
    font-size: small;
    width: 15%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid black;
    font-size: x-small;


}


.footer1 .secondParte .seconmdContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    /* border-left: 1px solid black;     */
}

.footer1 .secondParte .seconmdContent .row1 {
    display: flex;
    flex-direction: row;
    height: 30%;
    width: 100%;
    border-bottom: 1px solid black;
}

.footer1 .secondParte .seconmdContent .row2 {
    display: flex;
    flex-direction: column;
    height: 70%;
    width: 100%;
}

.footer1 .secondParte .seconmdContent .row1 .apto {
    width: 20%;
    height: 100%;
    border-right: 1px solid black;

}

.footer1 .secondParte .seconmdContent .row1 .apto .aptoTitle {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 30%;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
    background-color: rgba(128, 128, 128, 0.582);
}

.footer1 .secondParte .seconmdContent .row1 .precinto .precintoTitle {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 30%;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}



.footer1 .secondParte .seconmdContent .row1 .precinto {
    width: 80%;
}

.footer1 .secondParte .seconmdContent .row1 .apto .blankApto,
.footer1 .secondParte .seconmdContent .row1 .precinto .blankPrecinto {
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: xx-small;

}


.footer1 .secondParte .seconmdContent .row1 .apto,
.footer1 .secondParte .seconmdContent .row1 .precinto {
    display: flex;
    flex-direction: column;
}

.footer1 .secondParte .seconmdContent .row2 .firma {
    display: flex;
    flex-direction: row;
    height: 25%;
    border-bottom: 1px solid black;
}

.footer1 .secondParte .seconmdContent .row2 .nombre {
    display: flex;
    flex-direction: row;
    height: 50%;
    border-bottom: 1px solid black;
}

.footer1 .secondParte .seconmdContent .row2 .cedula {
    display: flex;
    flex-direction: row;
    height: 25%;
}

.footer1 .secondParte .seconmdContent .row2 .firma .firm,
.footer1 .secondParte .seconmdContent .row2 .nombre .firm,
.footer1 .secondParte .seconmdContent .row2 .cedula .firm {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    justify-content: center;
    font-weight: bold;
    font-size: x-small;
}

.footer1 .secondParte .seconmdContent .row2 .firma .blank,
.footer1 .secondParte .seconmdContent .row2 .nombre .blank,
.footer1 .secondParte .seconmdContent .row2 .cedula .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    border-left: 1px solid black;
    justify-content: center;
    text-transform: uppercase;
    align-items: center;
    font-weight: lighter;
    font-size: xx-small;
}

.footer2 {
    width: 100%;
    height: 146px;
    /* background-color: aqua; */
    border-top: 1px solid black;
    display: flex;
    flex-direction: row;
}

.footer2 .sellos {
    display: flex;
    flex-direction: column;
    width: 44%;
    height: 145px;
}

.footer2 .sellos .titleSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}

.footer2 .sellos .contentSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 40%;
    align-items: center;
    justify-content: center;
    display: flex;
}

.footer2 .sellos .titleOpLogis {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}

.footer2 .sellos .contentOtroSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 40%;
    align-items: center;
    justify-content: center;
    display: flex;
}
.footer2 .sellos .contentOtroSello2 {
    font-weight: bold;
    text-align: center;
    height: 100px;
    align-items: center;
    justify-content: center;
    display: flex;
}

.footer2 .sellos .otrosellos {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
}

.footer2 .sellos .contentOtroSello {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 40%;
    align-items: center;
    justify-content: center;
    display: flex;
}

.footer2 .primerParte {
    width: 50%;
    display: flex;
    flex-direction: column;
    /* background-color: rgb(226, 43, 165); */
    border-right: 1px solid black;
}

.footer2 .primerParte {
    border-right: 1px solid black;
}

.footer2 .terminal {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.footer2 .primerParte .terminal .vertical1 {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-align: center;
    font-size: 6pt;
    width: 13.2%;
    height: 144px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid black;
}

.footer2 .firmayNombre {
    width: 63.5%;
    border-right: 1px solid black;
    height: 145px;
}

.footer2 .firmayNombre .firma {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20%;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid black;
}

.footer2 .firmayNombre .firma .firm {
    width: 49.5%;
    border-right: 1px solid black;
    height: 100%;
    font-size: x-small;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.footer2 .firmayNombre .nombre {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 30%;
    border-bottom: 1px solid black;

}

.footer2 .firmayNombre .firm {
    width: 49.5%;
    border-right: 1px solid black;
    font-size: x-small;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-align: center;

}

.footer2 .firmayNombre .blank {
    width: 50%;
    font-size: xx-small;
    display: flex;
    justify-content: center;
    align-items: center;


}

.footer2 .firmayNombre .firma .percentI {
    display: flex;
    flex-direction: row;
    width: 78%;
    height: 100%;
    align-items: center;
}

.footer2 .firmayNombre .firma .percentI .firm {
    display: flex;
    flex-direction: column;
    width: 49.5%;
    height: 100%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
}

.footer2 .firmayNombre .firma .percentI .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
}

.footer2 .firmayNombre .firma .blankFirma {
    display: flex;
    flex-direction: column;
    width: 54%;
    height: 100%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
}

.footer2 .firmayNombre .nombreSelloDer {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 80%;
    border-bottom: 1px solid black;
}

.footer2 .firmayNombre .nombreSelloDer .selloDer {
    display: flex;
    flex-direction: column;
    width: 29.3%;
    height: 100%;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    justify-content: center;
    align-items: center;


}

.footer2 .firmayNombre .nombreSelloDer .selloDer .firm {
    font-size: 11px;
    font-weight: bold;
}

.footer2 .firmayNombre .nombreSelloDer .selloDer .firm2 {
    font-size: 11px;
    font-weight: bold;
    border-bottom: 1px solid black;
}

.footer2 .firmayNombre .nombreSelloDer .selloDer .blank {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.footer2 .firmayNombre .nombreSelloDer .infoIzq {
    display: flex;
    flex-direction: column;
    width: 71%;
    height: 100%;
    border-bottom: 1px solid black;
}

.footer2 .firmayNombre .nombreSelloDer .infoIzq .blank {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20%;
    border-bottom: 1px solid black;
}

.footer2 .firmayNombre .nombreSelloDer .infoIzq .nombre {
    display: flex;
    flex-direction: row;
    height: 80%;

}

.footer2 .firmayNombre .nombreSelloDer .infoIzq .nombre .firm {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 40%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
}

.footer2 .firmayNombre .nombreSelloDer .infoIzq .nombre .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: lighter;
}

.footer2 .firmayNombre .cedula {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 10%;
    border-bottom: 1px solid black;
}

.footer2 .firmayNombre .cedula .firm {
    display: flex;
    flex-direction: row;
    width: 49.5%;
    border-right: 1px solid black;
    text-align: center;
    justify-content: center;
    font-weight: bold;
}

.footer2 .secondParte {
    display: flex;
    flex-direction: row;
    width: 50%;
}

.footer2 .secondParte .vertical2 {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-align: center;
    font-size: small;
    width: 15%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid black;
}

.footer2 .secondParte .seconmdContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    /* border-left: 1px solid black;     */
}

.footer2 .secondParte .seconmdContent .row1 {
    display: flex;
    flex-direction: row;
    height: 30%;
    width: 100%;
}

.footer2 .secondParte .seconmdContent .row2 {
    display: flex;
    flex-direction: column;
    height: 70%;
    width: 100%;
}

.footer2 .secondParte .seconmdContent .row1 .apto {
    width: 20%;
    height: 100%;
    border-right: 1px solid black;

}

.footer2 .secondParte .seconmdContent .row1 .apto .aptoTitle {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 30%;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;
    background-color: rgba(128, 128, 128, 0.582);
}

.footer2 .secondParte .seconmdContent .row1 .precinto .precintoTitle {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid black;
    height: 30%;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: x-small;

}


.footer2 .secondParte .seconmdContent .row1 .precinto {
    width: 80%;
}

.footer2 .secondParte .seconmdContent .row1 .apto .blankApto,
.footer2 .secondParte .seconmdContent .row1 .precinto .blankPrecinto {
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: xx-small;
}

.footer2 .secondParte .seconmdContent .row1 .apto,
.footer2 .secondParte .seconmdContent .row1 .precinto {
    display: flex;
    flex-direction: column;
}

.footer2 .secondParte .seconmdContent .row2 .firma {
    display: flex;
    flex-direction: row;
    height: 40%;
    border-bottom: 1px solid black;
    font-size: x-small;
}

.footer2 .secondParte .seconmdContent .row2 .nombre {
    display: flex;
    flex-direction: row;
    height: 40%;
    border-bottom: 1px solid black;
    font-size: x-small;
}

.footer2 .secondParte .seconmdContent .row2 .cedula {
    display: flex;
    flex-direction: row;
    height: 20%;
    border-bottom: 1px solid black;
    font-size: x-small;
}

.footer2 .secondParte .seconmdContent .row2 .firma .firm,
.footer2 .secondParte .seconmdContent .row2 .nombre .firm,
.footer2 .secondParte .seconmdContent .row2 .cedula .firm {
    display: flex;
    flex-direction: column;
    width: 51%;
    height: 23, 3%;
    border-right: 1px solid black;
    justify-content: center;
    font-weight: bold;
}

.footer2 .secondParte .seconmdContent .row2 .firma .blank,
.footer2 .secondParte .seconmdContent .row2 .nombre .blank,
.footer2 .secondParte .seconmdContent .row2 .cedula .blank {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 80%;
    justify-content: center;
    font-size: xx-small;
    justify-content: center;
    align-items: center;
}

.footer2 .firmayNombre .placas {
    display: flex;
    flex-direction: row;
}

.footer2 .firmayNombre .placas .placaVehiculo {
    width: 50%;
    border-right: 1px solid black;
    height: 58px;
}

.footer2 .firmayNombre .placas .placaPlancha {
    width: 51%;
    height: 58px;
}

.footer2 .firmayNombre .placas .placaVehiculo .title {
    width: 100%;
    border-bottom: 1px solid black;
    font-size: x-small;
    font-weight: bold;
    text-align: center;
}

.footer2 .firmayNombre .placas .placaVehiculo .blank {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: xx-small;
    width: 100%;
    height: 80%;
}

.footer2 .firmayNombre .placas .placaPlancha .title {
    width: 100%;
    border-bottom: 1px solid black;
    font-size: x-small;
    font-weight: bold;
    text-align: center;
}

.footer2 .firmayNombre .placas .placaPlancha .blank {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: xx-small;
    width: 100%;
    height: 60%;
}

.losiguienteCierre {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
}

.losiguienteCierre .placas {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 60px;
}

.losiguienteCierre .placas .placaTruck {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    align-items: center;

}

.losiguienteCierre .placas .placaTruck .placaVehiculo {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 40%;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.losiguienteCierre .placas .placaTruck .blankPlaca {
    display: flex;
    justify-content: center;
    align-items: center;
}

.losiguienteCierre .placas .placaPlancha {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-bottom: 1px solid black;

}

.losiguienteCierre .placas .placaPlancha .blankPlaca {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;


}

.losiguienteCierre .placas .placaPlancha .placaPla {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 40%;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.losiguienteCierre .salidas {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.salidas {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}

.salidas .salida {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 300px;
    border-right: 1px solid black;
}

.salidas .salida .salidaTitle {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.salidas .salida .obv {
    display: flex;
    flex-direction: row;

}

.salidas .salida .obv .obv1 {
    display: flex;
    flex-direction: column;
    width: 50%;
    border-right: 1px solid black;
}

.salidas .salida .obv .obv1 .observacionesTitle {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 12px;
}

.salidas .salida .obv .blankNote {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 277px;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.entrada {
    width: 50%;
}

.entrada .entradaTitle {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid black;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.salidasEntradas {
    display: flex;
    flex-direction: row;
    background-color: rgba(128, 128, 128, 0.582);
    justify-content: space-around;
    width: 100%;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}

.salidasEntradas .salidas {
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 50%;
    border-right: 1px solid black;

}

.salidasEntradas .entradas {
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 50%;

}

.observaciones {
    display: flex;
    width: 100.3%;
    height: 175px;
    flex-direction: row;
}

.observaciones .observacionesTitle {
    display: flex;
    border-right: 1px solid black;
    width: 15%;
    justify-content: center;
    align-items: center;

}

.observaciones .observacionesSalidas {
    display: flex;
    width: 103.2%;
    border-right: 1px solid;
    height: 175px;
}

@page {
    size: A4;
    margin: 0;
    /* Para impresión sin márgenes */
}

@media print {
    body {
        margin-top: 5mm;
        /* Para asegurar que no haya márgenes al imprimir */
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Css/printComponet.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;;AAGA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;;AAElC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,6BAA6B;AACjC;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA,SAAS;;;AAGT,eAAe;;AAEf,eAAe;;AAEf;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,4CAA4C;;AAEhD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;;AAErB;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;AACf;;;AAGA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;;;AAGtB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,6BAA6B;;AAEjC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;;;AAIA;IACI,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;;AAEvB;;;AAGA;;IAEI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;;AAElC;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;;AAGvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;;;AAGvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,6BAA6B;;AAEjC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;;AAEtB;;;AAGA;IACI,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,cAAc;IACd,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,8BAA8B;;AAElC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;;AAGtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4CAA4C;IAC5C,6BAA6B;IAC7B,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,6BAA6B;;AAEjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI;QACI,eAAe;QACf,mDAAmD;IACvD;AACJ","sourcesContent":[".buttonDiv {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    margin-bottom: 24px;\n    gap:12px;\n}\n\n#print_container_checkList {\n    width: 816px;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    font-size: small;\n    border: 1px solid black;\n    padding: 0px;\n}\n\n/*HEADER*/\n.header {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 15%;\n    border: 1px solid black;\n}\n\n.header>.headerTitle {\n    font-weight: bold;\n    padding: 12px;\n    border-bottom: 1px solid black;\n    text-align: center;\n    background-color: rgba(128, 128, 128, 0.582);\n    height: 28%;\n}\n\n.header>.headerNumerocontenedor {\n    width: 100%;\n    height: 45%;\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerTipoContenedor {\n    width: 100%;\n    height: 45%;\n    display: flex;\n    flex-direction: row;\n}\n\n.header>.headerNumerocontenedor>.logo {\n    width: 10%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.header>.headerNumerocontenedor>.nrooContainer {\n    width: 60%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n    border-left: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.nrooContainer>.titlenroContainer {\n    width: 100%;\n    height: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.nrooContainer>.nroDescriptionContainer {\n    width: 100%;\n    height: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.header>.headerNumerocontenedor>.nrooContainer>.nroDescriptionContainer>.div1 {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-right: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.nrooContainer>.nroDescriptionContainer>.div2 {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta {\n    width: 30%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.patio {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.patio>.titlePatio {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.patio>.Fecha {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.patio>.Fecha div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-right: 1px solid black;\n}\n\n\n.header>.headerNumerocontenedor>.patioPlanta>.planta>.Fecha div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-right: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.patio>.FechaResult {\n    width: 100%;\n    height: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.patio>.FechaResult div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-right: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.planta {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.planta>.titlePlanta {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.planta>.Fecha {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.planta>.FechaResult {\n    width: 100%;\n    height: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.header>.headerNumerocontenedor>.patioPlanta>.planta>.FechaResult div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    border-right: 1px solid black;\n}\n\n\n.header>.headerTipoContenedor>.nroIdChequeo {\n    width: 10%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera {\n    width: 60%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n    border-left: 1px solid black;\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera>.patioOrigen {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    border-bottom: 1px solid black;\n\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera>.patioOrigen>.titlePatio {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n    font-weight: bold;\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera>.patioOrigen>.contentPatio {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera>.Naviera {\n    width: 100%;\n    height: 100%;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera>.Naviera>.titleNaviera {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n    font-weight: bold;\n}\n\n.header>.headerTipoContenedor>.descripcionPatiosNaviera>.Naviera>.contentNaviera {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.header>.headerTipoContenedor>.horaFecha {\n    display: flex;\n    width: 30%;\n    height: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent1 {\n    display: flex;\n    height: 100%;\n    width: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent1>.hora {\n    display: flex;\n    height: 40%;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent1>.hora>.horaTitle {\n    display: flex;\n    height: 100%;\n    width: 34%;\n    flex-direction: row;\n    border-right: 1px solid black;\n}\n\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent1>.hora>.horaDesc {\n    display: flex;\n    height: 100%;\n    width: 70%;\n    flex-direction: row;\n    justify-content: center;\n    align-items: start;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent2 {\n    display: flex;\n    height: 100%;\n    width: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid black;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent2>.hora {\n    display: flex;\n    height: 40%;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid black;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent2>.hora>.horaTitle {\n    display: flex;\n    height: 100%;\n    width: 35%;\n    flex-direction: row;\n    border-right: 1px solid black;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent1>.tipoRegistro {\n    display: flex;\n    height: 60%;\n    width: 100%;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 8pt;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent2>.tipoRegistro {\n    display: flex;\n    height: 60%;\n    width: 100%;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 8pt;\n}\n\n.header>.headerTipoContenedor>.horaFecha>.horaContent2>.hora>.horaDesc {\n    display: flex;\n    height: 100%;\n    width: 70%;\n    flex-direction: row;\n    justify-content: center;\n    align-items: start;\n}\n\n\n/*HEADER*/\n\n\n/*CUESTIONARIO*/\n\n/*CUESTIONARIO*/\n\n.answers {\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.answers>.respuestasOpciones {\n    width: 100%;\n    height: 3%;\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid black;\n}\n\n.answers>.respuestasOpciones>.spceBlank {\n    width: 70%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    border-right: 1px solid black;\n}\n\n.answers>.respuestasOpciones>.opciones {\n    display: flex;\n    flex-direction: row;\n    width: 30%;\n}\n\n.answers>.respuestasOpciones>.opciones>.op1 {\n    display: flex;\n    flex-direction: row;\n    width: 50%;\n}\n\n.answers>.respuestasOpciones>.opciones>.op1>div {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: center;\n    border-right: 1px solid black;\n    font-size: xx-small;\n}\n\n.answers>.respuestasOpciones>.opciones>.op2 {\n    display: flex;\n    flex-direction: row;\n    width: 50%;\n}\n\n.answers>.interiorContenenedorTitle {\n    width: 100%;\n    border: 1px solid black;\n    text-align: start;\n    height: auto;\n    padding: 0;\n\n}\n\n.answers>.respuestasOpciones>.opciones>.op2>div {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: center;\n    border-right: 1px solid black;\n    font-size: xx-small;\n}\n\n.answers>.interiorContenenedorTitle>.title {\n    font-weight: bold;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-size: x-small;\n    background-color: rgba(128, 128, 128, 0.582);\n\n}\n\n.answers>.interiorContent {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid black;\n}\n\n.answers>.interiorContent .contents {\n    display: flex;\n    width: 70%;\n    flex-direction: column;\n    border-right: 1px solid black;\n}\n\n.answers>.interiorContent .contents .content1,\n.answers>.interiorContent .contents .content2 {\n    text-align: start;\n    display: flex;\n    align-items: center;\n    height: auto;\n    /* Centra verticalmente */\n    justify-content: flex-start;\n    margin-left: 5px;\n    font-size: xx-small;\n\n}\n\n.answers>.interiorContent .opciones {\n    display: flex;\n    flex-direction: row;\n    width: 30%;\n}\n\n.answers>.interiorContent .opciones .op1 {\n    display: flex;\n    width: 50%;\n    border-right: 1px solid black;\n}\n\n.answers>.interiorContent .opciones .op1 div {\n    display: flex;\n    width: 100%;\n    border-right: 1px solid black;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    font-size: x-small;\n    font-weight: bold;\n}\n\n.answers>.interiorContent .opciones .op2 {\n    display: flex;\n    width: 50%;\n    border-right: 1px solid black;\n}\n\n.answers>.interiorContent .opciones .op2 div {\n    display: flex;\n    width: 100%;\n    border-right: 1px solid black;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    font-size: xx-small;\n    font-weight: bold;\n\n}\n\n\n.footer {\n    width: 99.8%;\n}\n\n.footer1 {\n    width: 100%;\n    height: 154px;\n    /* background-color: aqua; */\n    display: flex;\n    flex-direction: row;\n}\n\n.footer1 .primerParte {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    /* background-color: blueviolet; */\n    border-right: 1px solid black;\n}\n\n.footer1 .primerParte {\n    border-right: 1px solid black;\n}\n\n.footer1 .footerContentSellos {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    border-bottom: 1px solid black;\n}\n\n.footer1 .sellosCarat {\n    text-align: start;\n    width: 60%;\n    height: auto;\n    margin-left: 5px;\n    border-right: 1px solid black;\n    font-size: xx-small;\n    /* Espacio entre los elementos */\n}\n\n.footer1 .selloBtllaH {\n    text-align: center;\n    width: 40%;\n    display: flex;\n    flex-direction: column;\n}\n\n.footer1 .selloBtllaH .titleSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n.footer1 .selloBtllaH .descrSello {\n    font-weight: lighter;\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    justify-content: center;\n    height: 70%;\n    text-transform: uppercase;\n    font-size: x-small;\n}\n\n.footer1 .terminal {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.footer1 .primerParte .terminal .vertical1 {\n    writing-mode: vertical-rl;\n    transform: rotate(180deg);\n    text-align: center;\n    font-size: 6pt;\n    width: 12%;\n    height: 85px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-left: 1px solid black;\n}\n\n\n\n.footer1 .firmayNombre {\n    display: flex;\n    flex-direction: column;\n    width: 57.5%;\n    border-right: 1px solid black;\n    height: 84px;\n}\n\n.footer1 .firmayNombre .firma {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 14.5%;\n    border-bottom: 1px solid black;\n    font-size: x-small;\n}\n\n.footer1 .firmayNombre .firma .firm {\n    display: flex;\n    flex-direction: column;\n    width: 49.4%;\n    height: 100%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n    text-align: center;\n    align-items: center;\n   \n}\n\n.footer1 .firmayNombre .firma .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    justify-content: center;\n}\n\n.footer1 .firmayNombre .nombre {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 45%;\n    border-bottom: 1px solid black;\n}\n\n.footer1 .firmayNombre .nombre .firm {\n    display: flex;\n    flex-direction: column;\n    width: 49.4%;\n    height: 100%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n    font-size: x-small;\n    align-items: center;\n    text-align: center;\n}\n\n.footer1 .firmayNombre .nombre .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    justify-content: center;\n    font-size: xx-small;\n    text-align: center;\n}\n\n.footer1 .firmayNombre .cedula {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 36%;\n    /* border-bottom: 1px solid black; */\n}\n\n.footer1 .firmayNombre .cedula .firm {\n    display: flex;\n    flex-direction: column;\n    width: 49.4%;\n    height: 111%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n    font-size: x-small;\n    text-align: center;\n}\n\n.footer1 .firmayNombre .cedula .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    justify-content: center;\n    text-transform: uppercase;\n    font-size: xx-small;\n    text-align: center;\n}\n\n.footer1 .sellos {\n    display: flex;\n    flex-direction: column;\n    width: 40%;\n    height: 75%;\n}\n\n\n.footer1 .sellos .titleSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n.footer1 .sellos .contentSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 40%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.footer1 .sellos .titleOpLogis {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n.footer1 .secondParte {\n    width: 50%;\n    display: flex;\n    flex-direction: flex;\n    /* background-color: rgb(86, 48, 121); */\n}\n\n.footer1 .secondParte .vertical2 {\n    writing-mode: vertical-rl;\n    transform: rotate(180deg);\n    text-align: center;\n    font-size: small;\n    width: 15%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-left: 1px solid black;\n    font-size: x-small;\n\n\n}\n\n\n.footer1 .secondParte .seconmdContent {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    /* border-left: 1px solid black;     */\n}\n\n.footer1 .secondParte .seconmdContent .row1 {\n    display: flex;\n    flex-direction: row;\n    height: 30%;\n    width: 100%;\n    border-bottom: 1px solid black;\n}\n\n.footer1 .secondParte .seconmdContent .row2 {\n    display: flex;\n    flex-direction: column;\n    height: 70%;\n    width: 100%;\n}\n\n.footer1 .secondParte .seconmdContent .row1 .apto {\n    width: 20%;\n    height: 100%;\n    border-right: 1px solid black;\n\n}\n\n.footer1 .secondParte .seconmdContent .row1 .apto .aptoTitle {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 30%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n    background-color: rgba(128, 128, 128, 0.582);\n}\n\n.footer1 .secondParte .seconmdContent .row1 .precinto .precintoTitle {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 30%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n\n\n.footer1 .secondParte .seconmdContent .row1 .precinto {\n    width: 80%;\n}\n\n.footer1 .secondParte .seconmdContent .row1 .apto .blankApto,\n.footer1 .secondParte .seconmdContent .row1 .precinto .blankPrecinto {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    text-transform: uppercase;\n    font-size: xx-small;\n\n}\n\n\n.footer1 .secondParte .seconmdContent .row1 .apto,\n.footer1 .secondParte .seconmdContent .row1 .precinto {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer1 .secondParte .seconmdContent .row2 .firma {\n    display: flex;\n    flex-direction: row;\n    height: 25%;\n    border-bottom: 1px solid black;\n}\n\n.footer1 .secondParte .seconmdContent .row2 .nombre {\n    display: flex;\n    flex-direction: row;\n    height: 50%;\n    border-bottom: 1px solid black;\n}\n\n.footer1 .secondParte .seconmdContent .row2 .cedula {\n    display: flex;\n    flex-direction: row;\n    height: 25%;\n}\n\n.footer1 .secondParte .seconmdContent .row2 .firma .firm,\n.footer1 .secondParte .seconmdContent .row2 .nombre .firm,\n.footer1 .secondParte .seconmdContent .row2 .cedula .firm {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    justify-content: center;\n    font-weight: bold;\n    font-size: x-small;\n}\n\n.footer1 .secondParte .seconmdContent .row2 .firma .blank,\n.footer1 .secondParte .seconmdContent .row2 .nombre .blank,\n.footer1 .secondParte .seconmdContent .row2 .cedula .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    border-left: 1px solid black;\n    justify-content: center;\n    text-transform: uppercase;\n    align-items: center;\n    font-weight: lighter;\n    font-size: xx-small;\n}\n\n.footer2 {\n    width: 100%;\n    height: 146px;\n    /* background-color: aqua; */\n    border-top: 1px solid black;\n    display: flex;\n    flex-direction: row;\n}\n\n.footer2 .sellos {\n    display: flex;\n    flex-direction: column;\n    width: 44%;\n    height: 145px;\n}\n\n.footer2 .sellos .titleSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n.footer2 .sellos .contentSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 40%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.footer2 .sellos .titleOpLogis {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n.footer2 .sellos .contentOtroSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 40%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n.footer2 .sellos .contentOtroSello2 {\n    font-weight: bold;\n    text-align: center;\n    height: 100px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.footer2 .sellos .otrosellos {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n}\n\n.footer2 .sellos .contentOtroSello {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 40%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.footer2 .primerParte {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    /* background-color: rgb(226, 43, 165); */\n    border-right: 1px solid black;\n}\n\n.footer2 .primerParte {\n    border-right: 1px solid black;\n}\n\n.footer2 .terminal {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.footer2 .primerParte .terminal .vertical1 {\n    writing-mode: vertical-rl;\n    transform: rotate(180deg);\n    text-align: center;\n    font-size: 6pt;\n    width: 13.2%;\n    height: 144px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-left: 1px solid black;\n}\n\n.footer2 .firmayNombre {\n    width: 63.5%;\n    border-right: 1px solid black;\n    height: 145px;\n}\n\n.footer2 .firmayNombre .firma {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 20%;\n    align-items: center;\n    justify-content: space-around;\n    border-bottom: 1px solid black;\n}\n\n.footer2 .firmayNombre .firma .firm {\n    width: 49.5%;\n    border-right: 1px solid black;\n    height: 100%;\n    font-size: x-small;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n}\n\n.footer2 .firmayNombre .nombre {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    height: 30%;\n    border-bottom: 1px solid black;\n\n}\n\n.footer2 .firmayNombre .firm {\n    width: 49.5%;\n    border-right: 1px solid black;\n    font-size: x-small;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    text-align: center;\n\n}\n\n.footer2 .firmayNombre .blank {\n    width: 50%;\n    font-size: xx-small;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n\n}\n\n.footer2 .firmayNombre .firma .percentI {\n    display: flex;\n    flex-direction: row;\n    width: 78%;\n    height: 100%;\n    align-items: center;\n}\n\n.footer2 .firmayNombre .firma .percentI .firm {\n    display: flex;\n    flex-direction: column;\n    width: 49.5%;\n    height: 100%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n}\n\n.footer2 .firmayNombre .firma .percentI .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n}\n\n.footer2 .firmayNombre .firma .blankFirma {\n    display: flex;\n    flex-direction: column;\n    width: 54%;\n    height: 100%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n}\n\n.footer2 .firmayNombre .nombreSelloDer {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 80%;\n    border-bottom: 1px solid black;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .selloDer {\n    display: flex;\n    flex-direction: column;\n    width: 29.3%;\n    height: 100%;\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    justify-content: center;\n    align-items: center;\n\n\n}\n\n.footer2 .firmayNombre .nombreSelloDer .selloDer .firm {\n    font-size: 11px;\n    font-weight: bold;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .selloDer .firm2 {\n    font-size: 11px;\n    font-weight: bold;\n    border-bottom: 1px solid black;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .selloDer .blank {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 100%;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .infoIzq {\n    display: flex;\n    flex-direction: column;\n    width: 71%;\n    height: 100%;\n    border-bottom: 1px solid black;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .infoIzq .blank {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 20%;\n    border-bottom: 1px solid black;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .infoIzq .nombre {\n    display: flex;\n    flex-direction: row;\n    height: 80%;\n\n}\n\n.footer2 .firmayNombre .nombreSelloDer .infoIzq .nombre .firm {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 40%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n}\n\n.footer2 .firmayNombre .nombreSelloDer .infoIzq .nombre .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: lighter;\n}\n\n.footer2 .firmayNombre .cedula {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 10%;\n    border-bottom: 1px solid black;\n}\n\n.footer2 .firmayNombre .cedula .firm {\n    display: flex;\n    flex-direction: row;\n    width: 49.5%;\n    border-right: 1px solid black;\n    text-align: center;\n    justify-content: center;\n    font-weight: bold;\n}\n\n.footer2 .secondParte {\n    display: flex;\n    flex-direction: row;\n    width: 50%;\n}\n\n.footer2 .secondParte .vertical2 {\n    writing-mode: vertical-rl;\n    transform: rotate(180deg);\n    text-align: center;\n    font-size: small;\n    width: 15%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-left: 1px solid black;\n}\n\n.footer2 .secondParte .seconmdContent {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    /* border-left: 1px solid black;     */\n}\n\n.footer2 .secondParte .seconmdContent .row1 {\n    display: flex;\n    flex-direction: row;\n    height: 30%;\n    width: 100%;\n}\n\n.footer2 .secondParte .seconmdContent .row2 {\n    display: flex;\n    flex-direction: column;\n    height: 70%;\n    width: 100%;\n}\n\n.footer2 .secondParte .seconmdContent .row1 .apto {\n    width: 20%;\n    height: 100%;\n    border-right: 1px solid black;\n\n}\n\n.footer2 .secondParte .seconmdContent .row1 .apto .aptoTitle {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 30%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n    background-color: rgba(128, 128, 128, 0.582);\n}\n\n.footer2 .secondParte .seconmdContent .row1 .precinto .precintoTitle {\n    font-weight: bold;\n    text-align: center;\n    border-bottom: 1px solid black;\n    height: 30%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: x-small;\n\n}\n\n\n.footer2 .secondParte .seconmdContent .row1 .precinto {\n    width: 80%;\n}\n\n.footer2 .secondParte .seconmdContent .row1 .apto .blankApto,\n.footer2 .secondParte .seconmdContent .row1 .precinto .blankPrecinto {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    font-size: xx-small;\n}\n\n.footer2 .secondParte .seconmdContent .row1 .apto,\n.footer2 .secondParte .seconmdContent .row1 .precinto {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer2 .secondParte .seconmdContent .row2 .firma {\n    display: flex;\n    flex-direction: row;\n    height: 40%;\n    border-bottom: 1px solid black;\n    font-size: x-small;\n}\n\n.footer2 .secondParte .seconmdContent .row2 .nombre {\n    display: flex;\n    flex-direction: row;\n    height: 40%;\n    border-bottom: 1px solid black;\n    font-size: x-small;\n}\n\n.footer2 .secondParte .seconmdContent .row2 .cedula {\n    display: flex;\n    flex-direction: row;\n    height: 20%;\n    border-bottom: 1px solid black;\n    font-size: x-small;\n}\n\n.footer2 .secondParte .seconmdContent .row2 .firma .firm,\n.footer2 .secondParte .seconmdContent .row2 .nombre .firm,\n.footer2 .secondParte .seconmdContent .row2 .cedula .firm {\n    display: flex;\n    flex-direction: column;\n    width: 51%;\n    height: 23, 3%;\n    border-right: 1px solid black;\n    justify-content: center;\n    font-weight: bold;\n}\n\n.footer2 .secondParte .seconmdContent .row2 .firma .blank,\n.footer2 .secondParte .seconmdContent .row2 .nombre .blank,\n.footer2 .secondParte .seconmdContent .row2 .cedula .blank {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 80%;\n    justify-content: center;\n    font-size: xx-small;\n    justify-content: center;\n    align-items: center;\n}\n\n.footer2 .firmayNombre .placas {\n    display: flex;\n    flex-direction: row;\n}\n\n.footer2 .firmayNombre .placas .placaVehiculo {\n    width: 50%;\n    border-right: 1px solid black;\n    height: 58px;\n}\n\n.footer2 .firmayNombre .placas .placaPlancha {\n    width: 51%;\n    height: 58px;\n}\n\n.footer2 .firmayNombre .placas .placaVehiculo .title {\n    width: 100%;\n    border-bottom: 1px solid black;\n    font-size: x-small;\n    font-weight: bold;\n    text-align: center;\n}\n\n.footer2 .firmayNombre .placas .placaVehiculo .blank {\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    font-size: xx-small;\n    width: 100%;\n    height: 80%;\n}\n\n.footer2 .firmayNombre .placas .placaPlancha .title {\n    width: 100%;\n    border-bottom: 1px solid black;\n    font-size: x-small;\n    font-weight: bold;\n    text-align: center;\n}\n\n.footer2 .firmayNombre .placas .placaPlancha .blank {\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    font-size: xx-small;\n    width: 100%;\n    height: 60%;\n}\n\n.losiguienteCierre {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.losiguienteCierre .placas {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 60px;\n}\n\n.losiguienteCierre .placas .placaTruck {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    border-right: 1px solid black;\n    border-bottom: 1px solid black;\n    align-items: center;\n\n}\n\n.losiguienteCierre .placas .placaTruck .placaVehiculo {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 40%;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.losiguienteCierre .placas .placaTruck .blankPlaca {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.losiguienteCierre .placas .placaPlancha {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    border-bottom: 1px solid black;\n\n}\n\n.losiguienteCierre .placas .placaPlancha .blankPlaca {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n\n}\n\n.losiguienteCierre .placas .placaPlancha .placaPla {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 40%;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.losiguienteCierre .salidas {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.salidas {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: auto;\n}\n\n.salidas .salida {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 300px;\n    border-right: 1px solid black;\n}\n\n.salidas .salida .salidaTitle {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.salidas .salida .obv {\n    display: flex;\n    flex-direction: row;\n\n}\n\n.salidas .salida .obv .obv1 {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    border-right: 1px solid black;\n}\n\n.salidas .salida .obv .obv1 .observacionesTitle {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 40px;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    font-size: 12px;\n}\n\n.salidas .salida .obv .blankNote {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 277px;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.entrada {\n    width: 50%;\n}\n\n.entrada .entradaTitle {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n.salidasEntradas {\n    display: flex;\n    flex-direction: row;\n    background-color: rgba(128, 128, 128, 0.582);\n    justify-content: space-around;\n    width: 100%;\n    border-top: 1px solid black;\n    border-bottom: 1px solid black;\n}\n\n.salidasEntradas .salidas {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    width: 50%;\n    border-right: 1px solid black;\n\n}\n\n.salidasEntradas .entradas {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    width: 50%;\n\n}\n\n.observaciones {\n    display: flex;\n    width: 100.3%;\n    height: 175px;\n    flex-direction: row;\n}\n\n.observaciones .observacionesTitle {\n    display: flex;\n    border-right: 1px solid black;\n    width: 15%;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.observaciones .observacionesSalidas {\n    display: flex;\n    width: 103.2%;\n    border-right: 1px solid;\n    height: 175px;\n}\n\n@page {\n    size: A4;\n    margin: 0;\n    /* Para impresión sin márgenes */\n}\n\n@media print {\n    body {\n        margin-top: 5mm;\n        /* Para asegurar que no haya márgenes al imprimir */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
